module.exports = __webpack_public_path__ + "img/package.6e8dced1.svg";